<abs-messages>
    <div class="alert b2b-alerts-messages b2b-alerts-error valign-children-middle" id="error_container_id"
        *ngIf="showErr" tabindex="0">
        <div class="alert-error">
            <em class="icon-badgealert" role="img" aria-label="Error"></em>
            <button *ngIf="!invalidErrorDomain && !hideXicon" id="error_close_id" type="button" tabindex="0"
                class="close" #closeBtn aria-label="Close" (click)="dismissMe()"></button>
        </div>
        <div *ngIf="!invalidErrorDomain" id="error_message_id1">
            <p *ngFor="let message of messages" [innerHTML]="message"></p>
            <p *ngIf="showInfoLink.anchorText"><a (click)="redirectNow(showInfoLink.anchorLink)">
                    {{showInfoLink.anchorText}}</a></p>
        </div>
        <div *ngIf="invalidErrorDomain" id="error_message_id2">
            <p class="font14">{{cfetMessages.invalid_domain}}</p>
            <a class="font14" href="javascript:void(0)" (click)="returnToLogin()">{{cfetMessages.login_page}}</a>
        </div>
    </div>
</abs-messages>